module.exports = __webpack_public_path__ + "img/menu_app.def64c66.svg";